import constants from '../constants.js';

const PointsOfInterestList = {
  rootNode: true,
  displayName: 'Points of interest',
  iconClass: 'fa-pin',
  displayAs: constants.DISPLAY_AS.POINTS_OF_INTEREST
};

export default {
  PointsOfInterestList
}



// WEBPACK FOOTER //
// ./src/config/fields/pointsOfInterest.js